var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Intro'),_c('div',[_c('Games',{attrs:{"id":"games"}}),_c('About',{attrs:{"id":"about"}}),_c('Feedbacks',{attrs:{"id":"feedbacks"}}),_c('Contact',{attrs:{"id":"contact"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }